import { render, staticRenderFns } from "./FacebookPost.vue?vue&type=template&id=e196e688&scoped=true&"
import script from "./FacebookPost.vue?vue&type=script&lang=js&"
export * from "./FacebookPost.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPost.vue?vue&type=style&index=0&id=e196e688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e196e688",
  null
  
)

export default component.exports